<template>
  <div class="page-content animate__animated animate__fadeIn">
    <div class="border-bottom" style="margin-top:0;">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="线路名" prop="circuitId">
            <el-select clearable v-model="queryParams.circuitId" placeholder="请选择线路名进行查询" @change="circuitChange">
              <el-option v-for="item in circuitList" :key="item.circuitId" :label="item.circuitName"
                :value="item.circuitId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="行别">
            <el-select v-model="queryParams.lineType" placeholder="请选择行别" clearable @change="lineTypeChange">
              <el-option v-for="item in lineTypeList" :key="item.dictCode" :label="item.dictLabel"
                :value="item.dictValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="站区" prop="stationId" v-if="queryParams.lineType">
            <el-select v-model="queryParams.stationId" placeholder="请选择站区进行查询" clearable>
              <el-option v-for="item in stationList" :key="item.stationId" :label="item.stationName"
                :value="item.stationId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备名称">
            <el-input v-model="queryParams.componentName" placeholder="请输入设备名称进行查询" class="form-item-width"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="设备状态">
            <el-select clearable v-model="queryParams.state" placeholder="请选择设备状态进行查询">
              <el-option label="正常" value="0"></el-option>
              <el-option label="异常" value="1"></el-option>
              <el-option label="停用" value="2"></el-option>
            </el-select>
          </el-form-item>
          <div class="btn-boxs">
            <div>
              <el-button icon="el-icon-plus" type="primary" @click="handlecomponentAdd">新 增</el-button>
              <el-button :disabled="!multipleSelection.length" icon="el-icon-delete" type="danger"
                @click="batchDelete">批量删除</el-button>
            </div>
            <div>
              <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
              <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="margin-top" style="margin-bottom:0;margin-top:15px">
      <!-- 表格组件 -->
      <el-table v-loading="tableLoading" :data="tableData" border row-key="componentId" default-expand-all
        :tree-props="{ children: 'children' }" highlight-current-row max-height="447"
        :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize: '14px' }"
        @selection-change="handleSelectionChange">
        <!-- 多选 -->
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- 序号列 -->
        <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
        <!-- 动态生成其他列 -->
        <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name"
          show-overflow-tooltip :width="tab.width">
          <template slot-scope="scope">
            <!-- 针对 state 列的特殊处理 -->
            <span v-if="tab.code === 'state'" :style="{
          color: scope.row.state === '0' ? 'green' : scope.row.state === '1' ? 'red' : 'yellowgreen'
        }">{{ scope.row.state === '0' ? '正常' : scope.row.state === '1' ? '异常' : '停用' }}</span>
            <span v-else>{{ scope.row[tab.code] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
            <el-button style="color:red" type="text" @click="deleteData(scope.row)" class="update-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination background :total="pageParams.total" :page="pageParams.pageNum" :limit="pageParams.pageSize"
          @pagination="onChangePages" />
      </div>
    </div>
    <!-- 添加 修改角色 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisble" width="30%" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="110px">
        <el-form-item label="所属装置" prop="apparatusId">
          <el-select v-model="form.apparatusId" placeholder="请选择所属装置">
            <el-option v-for="item in apparatusList" :key="item.apparatusId" :label="item.apparatusName"
              :value="item.apparatusId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备名称" prop="componentName">
          <el-input maxlength="7" show-word-limit v-model="form.componentName" autocomplete="off"
            placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="设备编号" prop="componentNum">
          <el-input v-model="form.componentNum" autocomplete="off" placeholder="请输入设备设备编号"></el-input>
        </el-form-item>
        <el-form-item label="管辖部门" prop="deptId">
          <el-cascader placeholder="请选择管辖部门" v-model="form.deptId" :options="deptList" :show-all-levels="false"
            :props="{ value: 'deptId', label: 'deptName', checkStrictly: true, emitPath: false }"
            clearable></el-cascader>
        </el-form-item>
        <el-form-item label="所属区站" prop="stationId">
          <el-cascader placeholder="请选择所属区站" v-model="form.stationId" :options="stationData" clearable
            :props="{ emitPath: false }"></el-cascader>
        </el-form-item>
        <el-form-item label="状态" prop="state">
          <el-select v-model="form.state" placeholder="请选择状态">
            <el-option label="正常" value="0"></el-option>
            <el-option label="异常" value="1"></el-option>
            <el-option label="停用" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :icon="dialogTitle === '新增' ? 'el-icon-plus' : 'el-icon-edit'" type="primary"
          @click="submitForm('form')">{{ dialogTitle === '新增' ? '立即添加' : '立即修改' }}</el-button>
        <el-button icon="el-icon-refresh" @click="resetForm('form')">重 置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getComponentList, componentAdd, componentById, updeteComponent, deleteComponent} from "@/api/data-service/unit.js";
import { getCircuitTree } from "@/api/data-service/line.js";
import { getDeptTree } from "@/api/admin-service/dept";
import { getApparatusAll } from "@/api/data-service/apparatus.js";
import { getStationAll } from "@/api/data-service/station.js";
import { getCircuitAll } from "@/api/data-service/line.js";
import { getLineType } from "@/api/data-service/dict.js";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableLoading: false,
      form: {
        componentName: "", //设备名称
        componentNum: "", //设备设备编号
        apparatusId: "", //
        state: "", //
        deptId: "",
        stationId:""
      },
      rules: {
        componentName: [
          { required: true, message: "请填写设备名称", trigger: "blur" }
        ],
        componentNum: [
          { required: true, message: "请填写设备编号", trigger: "blur" }
        ],
        deptId: [{ required: true, message: "请选择部门", trigger: "change" }],
        stationId: [{ required: true, message: "请选择区站", trigger: "change" }],
        apparatusId: [
          { required: true, message: "请选择装置", trigger: "change" }
        ],
        state: [{ required: true, message: "请选择状态", trigger: "change" }]
      },
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      dialogFormVisble: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "设备名称", code: "componentName", width: "" },
        { name: "设备编号", code: "componentNum", width: "" },
        { name: "管辖部门", code: "deptName", width: "" },
        { name: "所属线路", code: "circuitName", width: "" },
        { name: "所属区站", code: "stationName", width: "" },
        { name: "装置", code: "apparatusName", width: "" },
        { name: "状态", code: "state", width: "" }
      ],

      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        componentName: "",
        state: "",
        stationId: "",
        circuitId: "",
        lineType: "",
      },
      apparatusList: [],
      deptList: [],
      multipleSelection: [],
      stationData: [],
      circuitList:[],
      lineTypeList:[],
      stationList:[]
    };
  },
  mounted() {
    this.onGetDataList();
    this.queryApparatusList();
    getDeptTree({}).then(res => {
      this.deptList = res.data;
    });
    getCircuitAll({}).then(res => {
      this.circuitList = res.data;
    });
    getLineType({}).then(res => {
      this.lineTypeList = res.data;
    });
    getCircuitTree({}).then(res => {
      this.stationData = res.data;
    });
  },

  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchDelete() {
      this.$confirm(`提示，确定要删除选中的这些数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          // 使用 map() 来获取 componentId 组成的数组
          const ids = (this.multipleSelection || []).map(
            item => item.componentId
          );
          deleteComponent({ ids }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    queryApparatusList() {
      getApparatusAll({
        apparatusName: "",
        ...this.pageParams
      }).then(res => {
        this.apparatusList = res?.data || [];
      });
    },
    addData() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    // 增 / 改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const formData = { ...this.form };
          delete formData.componentId; // 清除 componentId
          if (this.dialogTitle === "新增") {
            componentAdd({
              ...formData,
            }).then(res => {
              if (res.data) {
                this.$message.success(res.msg || "新增成功！");
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            });
          } else {
            updeteComponent({
              ...this.form,
              componentId: this.updateId,
            }).then(r => {
              if (r.data) {
                this.$message.success(r.msg || "修改成功！");
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删
    deleteData(row) {
      this.$confirm(`提示，确定要删除该条数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          deleteComponent({ ids: [row.componentId] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 改
    updateData(row) {
      this.dialogTitle = "修改";
      this.dialogFormVisble = true;
      this.updateId = row.componentId;
      componentById({ id: row.componentId }).then(res => {
        Object.assign(this.form, res.data);
      });
    },
    // 查
    onGetDataList() {
      this.tableLoading = true;
      getComponentList({
        ...this.queryParams,
        ...this.pageParams
      })
        .then(res => {
          const { records, total } = res.data;
          this.tableData = records;
          this.pageParams.total = total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    handlecomponentAdd() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    handleDialogClose() {
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = 10;
      this.queryParams.state = "";
      this.queryParams.componentName = "";
      this.queryParams.circuitId = "";
      this.queryParams.lineType = "";
      this.queryParams.stationId = "";
      this.onSearch();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.onGetDataList();
    },
    circuitChange(newValue) {
      this.queryParams.lineType = "";
      this.queryParams.stationId = "";
      this.queryParams.circuitId = newValue;
      this.circuitList.forEach(item => {
        if (item.circuitId === newValue) {
          if (item.type === "0") {
            // 说明是单线
            this.lineTypeList = [
              {
                dictLabel: "单线",
                dictValue: "0"
              }
            ];
          } else {
            this.lineTypeList = [
              {
                dictLabel: "上行",
                dictValue: "1"
              },
              {
                dictLabel: "下行",
                dictValue: "2"
              }
            ];
          }
        }
      });
    },
    lineTypeChange(val) {
      this.queryParams.stationId = "";
      this.queryStaionList(this.queryParams.circuitId, val);
    },
    queryStaionList(circuitId, lineType) {
      getStationAll({
        stationName: "", //区站名称
        circuitId,
        lineType,
        ...this.pageParams
      }).then(res => {
        this.stationList = res?.data || [];
      });
    },
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  height: 95vh;
}

.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.custom-tree-node {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .tree-node-label {
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
